export default {"src":"/_next/static/media/paymentmethod.08173780.svg","height":108,"width":747,"blurWidth":0,"blurHeight":0};